import { IAppParams } from './interfaces'

export class AppParams implements IAppParams {
  static version = '1.0.0'
  iptv = true
  siteId = ''
  platform_id = ''
  parent = ''
  apiEnv = ''
  fuseEnv = ''
  buildVer = ''
  testDeviceId = ''
  testCountry = ''
  testCcEnabled = false
  debugConsole = false
  enableGridAnim = false
  testAdMp4 = false
  testAdMode = false
  testAdTag = ''
  testAdsIds = ''
  testApiIp = ''
  nodeEnv = 'prod'
  partner = ''
  testAdTimeout = false
  disableAds = false
  enableMidrolls = true
  reloadOnError = true
  testIndexError = false
  testSubCategoryError = false
  testVideoError = false
  testAdsProviders = ''
  testIMAAdPodding = ''
  enableIMAAdPodding = ''
  testIMAMacro = false
  testAutoplay = ''
  env = ''
  testDisableToken = false
  testEnableNativePlayer = false
}
